import axios from 'axios';

/**
 * @see https://chatgpt.com/c/19687108-f664-4b59-a60c-fe093768c90e
 * @type {axios.AxiosInstance}
 */
const axiosInstance = axios.create({
  // You can set baseURL or any other default settings here if needed
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => response, // Just return the response if it's successful
  error => {
    if (error.response && error.response.status === 401) {
      // Handle 401 error
      console.log('Unauthorized access - maybe redirect to login page or show a message');
      // Optionally, you can return a specific value or Promise here
      return Promise.reject(error); // or return something else if needed
      //return new Promise(() => {});
    }
    // For all other errors, rethrow the error so it can be caught by other error handlers
    return Promise.reject(error);
  }
);

export default axiosInstance;
